import { Component, OnInit, TemplateRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxBrazilMASKS, NgxBrazilValidators } from 'ngx-brazil';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { BuyerService } from '../_services/buyer.service';
import { BuyerPurchaseService } from './comprar.service';
import { GeneralService } from 'app/_services/general.service';
import { NotificationService } from 'app/_services/notification.service';

import { capitalizeFirstLetter, deepCopy } from 'app/_utils/general-utils';

import { Globals } from 'app/_models/globals';
import { RoutingState } from 'app/_utils/routingstate';
import { DisplayMessage, GenericValidator, ValidationMessages } from 'app/_utils/generic-form-validation';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { BuyerPurchasesGetChosenAnswersResponseModel } from './_models/buyerPurchasesGetChosenAnswersResponseModel';
import { CheckoutModalResponseEnum, VerMaisDetalhesModalResponseEnum } from './_models/modalEnum';
import { CrispTemplateEnum } from 'app/_models/crisp';
import { DeliveryTimeDetailed } from 'app/_models/deliveryTime';
import { HeaderApiResponse } from './_models/headerApiResponse';
import { Item } from './_models/item';
import { Pedido } from './_models/pedido';
import { PurchaseAreaHeader } from './_models/purchaseAreaHeader';
import { CheckoutAnswer, CheckoutAnswerPart, PurchaseAreaResponse } from './_models/purchaseAreaResponses';
import { CotacaoSelecionada } from './_models/cotacaoSelecionada';
import { Part, EditPartItem } from './_models/part';
import { PaymentType } from 'app/_models/paymentType';
import { SendLinkResponseModel } from 'app/support/cotacoes/_models/sendLinkResponseModel';
import { Shipping } from './_models/shipping';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { TipoAlerta } from './_models/tipoAlerta';
import { TipoCalculoTotalEnum } from './_models/tipoCalculoTotalEnum';
import { WhatsAppMessage } from 'app/_models/whatsAppMessage';

import { BuyerComprarCheckoutModalComponent } from './_componentes/checkout-modal/checkout-modal.component';
import { BuyerComprarRespostaAvaliacaoModalComponent } from './_componentes/resposta-avaliacao-modal/resposta-avaliacao-modal.component';
import { BuyerComprarRespostaRodapeComponent } from './_componentes/resposta-rodape/resposta-rodape.component';
import { BuyerComprarVerMaisDetalhesModalComponent } from './_componentes/ver-mais-detalhes-modal/ver-mais-detalhes-modal.component';
import { SettingsService } from 'app/_services/settings.service';
import { UserService } from 'app/_services/user.service';
import { BroadCastEventEnum } from 'app/_models/_enums/broadCastEvent.enum';

declare const $: any;
declare const copyToClipboard: any;
declare const findInArray: any;
declare const formatDateToYYYYMMDD: any;
declare const getDateAfterAddWorkDays: any;
declare const getOnlyNumbers: any;
declare const getWorkDaysCount: any;
declare const isEmpty: any;
declare const numberWithTwoDecimals: any;
declare const sort_by: any;
declare const waitForElm: any;

@Component({
    selector: 'app-comprar', templateUrl: './comprar.component.html', styleUrls: ['./comprar.component.scss'],
    standalone: false
})

export class BuyerVisaoGeralComprarComponent implements OnInit {
    private max_days_delivery: number = 40;
    capitalizeFirstLetter: any = capitalizeFirstLetter;
    isScreenLoaded: boolean = false;

    isInsumosWithoutVehicle: boolean;
    isUsuarioLocalPlanoPopular: boolean;
    isUsuarioLocalPlanoCentral: boolean;

    cotacaoCache: any;
    cotacaoCachePecasSelecionadas: any = [];
    isCotacaoSalva: boolean = false;

    transaction_id: number;
    tipo_ordenacao: any;
    tipo_filtro: any;
    purchaseAreaBaseData: PurchaseAreaHeader;
    calendarMaxDate: any;
    calendarMinDate: any;
    calendarMarkDisabled: any;
    cotacaoEdicao: any;
    cotacaoSelecionada: CotacaoSelecionada;
    deliveryTimes: DeliveryTimeDetailed[];
    directWhatsappIntegration: boolean = false;
    feriados: string[];
    loading_comprar: boolean;
    respostaTipoAlerta: TipoAlerta = {};
    partUsedPrefix: string = 'U';
    vendedorRespostas: PurchaseAreaResponse[];
    vendedorRespostasFiltradas: PurchaseAreaResponse[];
    bodyText: string;
    listas: any;
    IsChosenFilter: any = { is_chosen: true };
    IsChosenHasCashbackFilter: any = { is_chosen: true, has_cashback: true };
    ShouldDisplayFilter: any = { displayPart: true };
    isOnError: boolean;
    translateFaltamPecas: any;
    valorTotalPedido: number = 0;

    alreadySended: boolean;
    selectedOrder: { quotationId: number, sellerCompanyId: number } = null;

    @ViewChild('templateAdicionarVendedorExterno') templateAdicionarVendedorExterno: TemplateRef<any>;
    @ViewChild('templateCompra', { static: true }) templateCompra: TemplateRef<any>;
    @ViewChild('templateMaisDetalhes') templateMaisDetalhes: TemplateRef<any>;
    @ViewChild('templatePecasFaltantes') templatePecasFaltantes: TemplateRef<any>;
    @ViewChild('modalCheckoutComponent') modalCheckoutComponent: BuyerComprarCheckoutModalComponent;
    @ViewChild('modalRespostaAvaliacaoComponent') modalRespostaAvaliacaoComponent: BuyerComprarRespostaAvaliacaoModalComponent;
    @ViewChild('modalVerMaisDetalhesComponent') modalVerMaisDetalhesComponent: BuyerComprarVerMaisDetalhesModalComponent;
    @ViewChildren(BuyerComprarRespostaRodapeComponent) respostasRodape: QueryList<BuyerComprarRespostaRodapeComponent>;
    modalAdicionarVendedorExterno: BsModalRef;
    modalCompra: BsModalRef;
    modalMaisDetalhes: BsModalRef;
    modalPecasFaltantes: BsModalRef;
    modal_visivel: { adicionar_complemento: boolean, comentarios: boolean, editar_cotacao: boolean, editar_peca: boolean };

    displayMessage: DisplayMessage = {};
    genericValidator: GenericValidator;
    vendedorExternoPecasSelecionadas: number[] = [];
    vendedorExternoForm: UntypedFormGroup;
    validationMessages: ValidationMessages;
    loading: any;

    public MASKS: any = NgxBrazilMASKS;

    editIsBO: Boolean = false;

    constructor(
        public accountService: AccountService,
        public userService: UserService,
        private baseService: BaseService,
        private buyerService: BuyerService,
        private buyerPurchaseService: BuyerPurchaseService,
        private generalService: GeneralService,
        private notificationService: NotificationService,
        private settingService: SettingsService,
        private globals: Globals,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private calendar: NgbCalendar,
        private ngxLoader: NgxUiLoaderService,
        private router: Router,
        private fb: UntypedFormBuilder,
        private routingState: RoutingState,
        private translate: TranslateService)
    {
        this.directWhatsappIntegration = this.generalService.directWhatsappIntegration;

        this.ngxLoader.startLoader('loader-principal');
        this.generalService.getDeliveryDateByWorkingDays(this.max_days_delivery).subscribe({
            next: (response: ApiResponseModel<{deliveryDate: any}>) => {
                let hoje = new Date();
                let maxDate = new Date(response.result.deliveryDate);
                this.calendarMinDate = { year: hoje.getFullYear(), month: hoje.getMonth() + 1, day: hoje.getDate() };
                this.calendarMaxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
            }
        });

        this.ngxLoader.startLoader('loader-principal');

        this.loading = { cotacoes: false, vendedores: false, vendedor_externo: false };

        this.validationMessages = {
            cnpj: { required: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.cnpj.obrigatorio'), cnpj: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.cnpj.formato') },
            empresa: { required: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.empresa.obrigatorio') },
            vendedor: { required: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.vendedor.obrigatorio') },
            whatsapp: { required: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.whatsapp.obrigatorio'), telefone: this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.campos-mensagens.whatsapp.formato') },
        };

        this.genericValidator = new GenericValidator(this.validationMessages);

        this.baseService.broadCastChannel.onmessage = (event) => {
            if(event.tipo === BroadCastEventEnum.RecarregarCotacaoEvent) {
                this.listarRespostas(this.transaction_id);
            }

            if(event.tipo === BroadCastEventEnum.FecharGuiaEvent) {
                close()
            }
        }
    }

    ngOnInit() {
        this.isInsumosWithoutVehicle = false;
        this.modal_visivel = { adicionar_complemento: false, comentarios: false, editar_cotacao: false, editar_peca: false };

        this.isUsuarioLocalPlanoPopular = this.userService.userPlan() === 1;
        this.isUsuarioLocalPlanoCentral = this.userService.userPlan() === 3;

        this.isScreenLoaded = false;

        this.vendedorRespostas = [];
        this.vendedorRespostasFiltradas = [];
        this.listas = { cnpjs: [] };

        // Obtém o id da cotação passado por parâmetro
        var param_id = this.route.snapshot.params.id;
        var isValid = /^\d+$/.test(param_id);
        this.isOnError = !isValid;
        this.loading_comprar = false; // Se está rodando loading na área de comprar

        if (isValid) {
            this.transaction_id = parseInt(param_id);
            this.tipo_ordenacao = this.userService.userHasCashback() ? "1" : "2";
            this.tipo_filtro = "todos";
            this.listarRespostas(this.transaction_id, true);
        }

        this.vendedorExternoForm = this.fb.group({
            cnpj: ['', [Validators.required, NgxBrazilValidators.cnpj]],
            empresa: ['', Validators.required],
            vendedor: ['', Validators.required],
            whatsapp: ['', [Validators.required, NgxBrazilValidators.phoneNumber]],
            tipoNC: ['nc']
        });

        this.displayMessage = {};

        this.vendedorExternoForm.patchValue({ cnpj: '', empresa: '', vendedor: '', whatsapp: '' });
    }

    ngAfterViewChecked()
    {
        // Caso a tela esteja com erro, volta para a home
        if (this.isOnError)
            this.voltar({ corpo: 'buyer.cotacao.mensagens.listar.erro.sem-codigo', parametro: '' });
    }

    acertarLimites(vendedorRespostas: PurchaseAreaResponse[]) {
        $.each(vendedorRespostas, function (i, resposta: PurchaseAreaResponse) {
            var gasto = 0;

            // Percorre todas as peças da resposta fazendo o calculo total
            $.each(resposta.pecas, function (j, peca: Part) {
                if (peca.is_chosen)
                    gasto += parseFloat(((peca.preco_final * 100) / 100).toString());
            });
        });
    }

    alinharDesconto(answer: any, somenteSelecionadas: boolean) {
        const answerDiscount : any = { parts: answer.novoValor.itens };
        this.modalCheckoutComponent.alinharDesconto(answerDiscount, somenteSelecionadas);
    }

    atualizarCache() {
        const respostasComPecasSelecionadas = this.respostasPecasSelecionadas();
        let pecasSelecionadas = [];

        respostasComPecasSelecionadas.map(resposta => {
            pecasSelecionadas.push(... resposta.pecas.filter(i => i.is_chosen).map(i => ({ item_answer_id: i.item_answer_id, quantity: (i.selectedQuantity ?? 1) })));
        });

        this.cotacaoCachePecasSelecionadas = pecasSelecionadas;
    }

    atualizarDadosPecas(vendedorRespostas: PurchaseAreaResponse[]) {
        var codigovazio = this.globals.translate('buyer.cotacao.area-respostas.resposta.pecas.codigo-antigo.vazio');

        vendedorRespostas.forEach(resposta => {
            let precoCiaTotal = 0;
            let precoRespostaTotal = 0;

            if(resposta.pecas == null) {
                resposta.pecas = [];
            }

            resposta.pecas.sort(sort_by([{ name: 'item_name' }]));

            resposta.pecas.forEach(peca => {
                let tipo_peca = peca.part_type === 1 ? 'G' : (peca.part_type === 2 ? 'O' : 'A');
                let codigo = peca.new_part_code && peca.new_part_code.trim().length > 0 ? `${peca.new_part_code.trim()} - ` : (peca.item_part_code && peca.item_part_code.trim().length > 0 ? `${peca.item_part_code} - ` : '');

                let partUsedPrefix = peca.is_used ? `(${this.partUsedPrefix}) ` : '';

                peca.name_code_parttype = `${partUsedPrefix}(${tipo_peca}) ${codigo}${peca.item_name}`;
                peca.unityFinalPrice = peca.price * (1 - (peca.discount / 100));
                peca.preco_final = peca.preco_final_original = numberWithTwoDecimals(peca.answer_quantity * peca.unityFinalPrice);

                peca.is_chosen = false;
                peca.tooltip_code = !isEmpty(peca.item_part_code) ? peca.item_part_code : codigovazio;
                peca.displayPart = true;
                peca.selectedQuantity = 0;
                peca.other_selected_quantity = 0;

                let complemento_melhor_prazo = peca.delivery_time.is_PF ? '.pf' : (peca.delivery_time.is_BO ? '.bo' : '.pe');
                peca.tooltip_prazo =
                    (peca.melhor_prazo ?
                        'buyer.cotacao.area-respostas.resposta.pecas.melhor-prazo' + complemento_melhor_prazo :
                        (peca.delivery_time.is_PF ?
                            'buyer.cotacao.area-respostas.resposta.pecas.pedido-fabrica' :
                            (peca.delivery_time.is_BO ?
                                'buyer.cotacao.area-respostas.resposta.pecas.back-order' :
                                'buyer.cotacao.area-respostas.resposta.pecas.peca-estoque'
                            )
                        )
                    );

                peca.podeGerarCashbackCustomizado = (this.userService.userIsCentral() || this.userService.userPlan() < 3) && this.userService.userHasCashback() && resposta.has_cashback && peca.discount_original > 0;

                precoCiaTotal += numberWithTwoDecimals(peca.quantity * (peca.insurance_price * (1 - (peca.insurance_discount / 100))));
                precoRespostaTotal += numberWithTwoDecimals(peca.quantity * (peca.price * (1 - (peca.discount / 100))));
            });

            resposta.total_pecas = numberWithTwoDecimals(precoRespostaTotal);
            resposta.total_pecas_cia = numberWithTwoDecimals(precoCiaTotal);
            resposta.total_pecas_frete = numberWithTwoDecimals(resposta.total_pecas + resposta.shipping_cost);

            resposta.frete_formatado = this.editarResposta_FormatarFrete({ shipping_cost: isEmpty(resposta.shipping_cost) ? 0 : resposta.shipping_cost, buyer_responsability: resposta.buyer_responsability });
        });

        return vendedorRespostas;
    }

    atualizarFormaPagamento(resposta: PurchaseAreaResponse) {
        if (isEmpty(resposta))
            return;

        const is_pagamento_avista = resposta.payment_type == 0;
        let max_tipo_pagamento = [];

        if (!resposta.can_be_financed || is_pagamento_avista) {
            resposta.tipo_pagamento = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.pagamento-a-vista');
            resposta.tipo_pagamento_tooltip = `${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.faturamento-nao-liberado')} - ${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade')}`;
            return;
        }

        const tem_condicoes_fornecimento_concluido_tem_formas_pagamento = resposta.done_configuration && !isEmpty(resposta.payment_types);

        // Insere na lista as formas que estão acima do valor selecionado E não são a vista E estão na lista que foi selecionada pelo vendedor
        if (resposta.can_be_financed && tem_condicoes_fornecimento_concluido_tem_formas_pagamento) {
            max_tipo_pagamento = resposta.payment_types.filter(fp => fp.startValue <= resposta.total_pecas).map(fp => fp.paymentType);

            if (max_tipo_pagamento.length > 0) {
                if (max_tipo_pagamento[max_tipo_pagamento.length - 1].id > 0)
                    resposta.tipo_pagamento = this.globals.translate('buyer.cotacao.area-comprar.selecionados.rodape.faturamento.faturado-ate') + max_tipo_pagamento[max_tipo_pagamento.length - 1].texto;
                else {
                    resposta.tipo_pagamento = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.pagamento-a-vista');
                    resposta.tipo_pagamento_tooltip = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade');
                }
            }
        }
    }

    atualizarIsChosenTodasRespostas (vendedorRespostas: PurchaseAreaResponse[]) {
        let total = 0;

        vendedorRespostas.forEach(resposta => {
            resposta.is_chosen = resposta.pecas.some(peca => peca.is_chosen);
            this.setarTipoFrete(resposta);

            resposta.total_selecionado = resposta.is_chosen ? this.buyerPurchaseService.getOrderValueFromAnswer(resposta, TipoCalculoTotalEnum.TotalEscolhido).total : 0;
            total += resposta.total_selecionado;

            this.setarTipoFaturamento(resposta);
            this.verificarHeader(resposta);
        });

        this.valorTotalPedido = total;
        this.rebuildAnswersFooter();
    }

    atualizarDadosPecaAposChangeSelectedQuantity(item_id: number, vendedorRespostas: PurchaseAreaResponse[]) {
        const filteredPecas = vendedorRespostas.reduce((acc, resposta) => {
            const pecasFiltradas = resposta.pecas.filter(p => p.item_id === item_id);
            return acc.concat(pecasFiltradas);
          }, []);

        filteredPecas.forEach(peca => {
            const total_others = filteredPecas.filter(p => p.item_answer_id !== peca.item_answer_id).reduce((acc, p) => acc + p.selectedQuantity, 0);
            peca.other_selected_quantity = total_others;

            const quantity = peca.selectedQuantity > 0 ? peca.selectedQuantity : peca.answer_quantity;
            peca.preco_final = numberWithTwoDecimals(quantity * peca.unityFinalPrice);
        });

        this.atualizarIsChosenTodasRespostas(vendedorRespostas);
        this.atualizarCache();
    }

    atualizarValidacao() {
        this.displayMessage = this.genericValidator.processarMensagens(this.vendedorExternoForm);
    }

    calcularMelhorPrecoPrazo() {
        // Percorre todas as peças de todas as respostas *definindo* os melhores preços e prazos
        this.purchaseAreaBaseData?.itens.forEach(item => {
            // Filtra todas as respostas que possuem a peça
            const pecas = this.vendedorRespostas.flatMap(r => r.pecas.filter(p => p.item_id === item.id && p.delivery_time_id < 99));
            const minPrice = Math.min(...pecas.map(p => (p.unityFinalPrice)));
            const minDeliveryTime = Math.min(...pecas.map(p => p.delivery_time_id));

            pecas.forEach(p => {
                p.melhor_preco = p.unityFinalPrice == minPrice ? true : null;
                p.melhor_prazo = p.delivery_time_id == minDeliveryTime ? true : null;
            }); // Seta as peças com melhor preço e prazo
        });
    }

    calculatePartIsUsedAnswer() {
        this.vendedorRespostasFiltradas.forEach(response => {
            response.hasPartIsUsed = response.pecas?.some(part => part.is_used) ?? false;
        });
    }

    async changeAnswerQuantity(peca: any, vendedorRespostas: PurchaseAreaResponse[]) {
        // Se o valor for menor do que zero
        if (peca.answer_quantity <= 0) {
            peca.answer_quantity = 1;
            return;
        }

        // Se o valor for maior do que a quantidade solicitada
        if (peca.answer_quantity > peca.quantity) {
            peca.answer_quantity = peca.quantity;
            await this.notificationService.showWarning('buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.solicitada.corpo', 'buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.solicitada.titulo');
            return;
        }

        // Se o valor for menor do que o valor que já foi selecionado
        if (peca.answer_quantity < peca.selectedQuantity) {
            peca.selectedQuantity = peca.answer_quantity;
            this.atualizarDadosPecaAposChangeSelectedQuantity(peca.item_id, vendedorRespostas);
        }
    }

    async changeSelectedQuantity(peca: Part, vendedorRespostas: PurchaseAreaResponse[]) {
        if (peca.selectedQuantity > 0 && peca.selectedQuantity + peca.other_selected_quantity <= peca.quantity && peca.selectedQuantity <= peca.answer_quantity) {
            peca.is_chosen = true;
            this.atualizarDadosPecaAposChangeSelectedQuantity(peca.item_id, vendedorRespostas);
            return;
        }

        // Se o valor for menor do que zero
        if (peca.selectedQuantity <= 0) {
            peca.selectedQuantity = 0;
            peca.is_chosen = false;
            this.atualizarDadosPecaAposChangeSelectedQuantity(peca.item_id, vendedorRespostas);
            return;
        }

        // Se o valor selecionado for maior do que a resposta do vendedor
        if (peca.selectedQuantity > peca.answer_quantity) {
            peca.selectedQuantity = peca.answer_quantity;
            await this.notificationService.showWarning('buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.vendedor.corpo', 'buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.vendedor.titulo');
            return;
        }

        // Se o valor selecionado + os outros valores dos outros vendedores for maior do que a quantidade solicitada
        if (peca.selectedQuantity + peca.other_selected_quantity > peca.quantity) {
            peca.selectedQuantity = peca.quantity - peca.other_selected_quantity;
            await this.notificationService.showWarning('buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.outros.corpo', 'buyer.cotacao.area-respostas.resposta.pecas.erro.quantidade.outros.titulo');
            return;
        }

        peca.is_chosen = true;
        this.atualizarDadosPecaAposChangeSelectedQuantity(peca.item_id, vendedorRespostas);
    }

    copyGetAnswer() {
        // "Nova oportunidade da oficina {{1}} na Partsfy!🚙
        // {{1}}
        // Aproveite: {{2}}
        // Ficamos à disposição caso precise de ajuda."
        const companyName = this.userService.user()?.selectedUser?.current_company_name;
        let urlPartsfy = this.generalService.getPartsfyUrl();
        let urlCotacao = urlPartsfy + '/vendedor/visao-geral/responder/' + this.cotacaoSelecionada.id;
        let oficina = companyName;
        let veiculo = this.cotacaoSelecionada.brand.name + " - (" + this.cotacaoSelecionada.license_plate + ") " + this.cotacaoSelecionada.vehicle + " - " + this.cotacaoSelecionada.year;
        let chassi = this.cotacaoSelecionada.chassi;

        this.ngxLoader.startLoader('loader-principal');

        this.generalService.getCrispTemplate(CrispTemplateEnum.NovaCotacaoV2).subscribe({
            next: (response: ApiResponseModel<{message: string}>) => {
                if (response && response.success) {
                    var text = response.result.message;
                    text = text.replace('{{1}}', `${oficina}`);
                    text = text.replace('{{1}}', `${veiculo} - ${chassi}`);
                    text = text.replace('{{2}}', `${urlCotacao}`);

                    copyToClipboard(text);
                    this.notificationService.showSuccessToastr(this.globals.translate('geral.info-geral.mensagens.info-copiada.sucesso'));
                    this.ngxLoader.stopLoader('loader-principal');
                } else {
                    this.notificationService.showErrorToastr(this.globals.translate('geral.info-geral.mensagens.info-copiada.erro'));
                }
            },
            error: () => {
                this.ngxLoader.stopLoader('loader-principal');
            }
        })
    }

    editDateChanged($event, peca: EditPartItem) {
        if (typeof peca.data_entrega == 'string')
            return;

        let data_entrega = new Date($event.year, $event.month - 1, $event.day);
        data_entrega.setHours(data_entrega.getHours() + 3);

        let isHoliday = this.feriados.some(x => x === formatDateToYYYYMMDD(data_entrega, '-'));

        if (isHoliday) {
            data_entrega = getDateAfterAddWorkDays(data_entrega, 1);
            peca.data_entrega = new NgbDate(data_entrega.getDate(), data_entrega.getMonth() + 1, data_entrega.getFullYear());
        }

        let hoje = new Date();
        hoje.setHours(3, 0, 0);

        let working_days = getWorkDaysCount(hoje, data_entrega, this.feriados);

        peca.showPF = working_days > 1;
        peca.lockPF = working_days > 4;

        if(working_days > 4)
            peca.editIsPF = true;
    }

    async editarResposta_Abrir(resposta: PurchaseAreaResponse) {
        resposta.novoValor = { itens: [], frete: {
            valor: resposta.shipping_cost,
            tipo: (resposta.shipping_cost <= 0 && !resposta.buyer_responsability) ? 1 : 2,
            conta_comprador: resposta.buyer_responsability,
            nao_entrega: !resposta.deliver,
            was_changed: resposta.was_changed
        } };
        resposta.is_chosen = false;

        const daysList = resposta.pecas
                                    .filter(p => p.delivery_time.delivery_time_day && p.delivery_time.delivery_time_day < 99)
                                    .map(p => (p.delivery_time.delivery_time_day));

        if(resposta.pecas.every(p => p.delivery_time_id == 99)) {
            this.editarResposta_Abrir_Execution(resposta, []);
            return;
        }

        this.generalService.getAllDeliveryDatesByWorkingDays(daysList).subscribe({
            next: (response: ApiResponseModel<{deliveryDates: { day: number, deliveryDate: Date }[]}>) => {
                const deliveryDates = response.result.deliveryDates;
                this.editarResposta_Abrir_Execution(resposta, deliveryDates);
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    private editarResposta_Abrir_Execution(resposta: PurchaseAreaResponse, deliveryDates: {day: number, deliveryDate: Date}[]) {
        const pecas = resposta.pecas.sort(sort_by([{ name: 'item_name' }]));

        for (let i = 0; i < pecas.length; i++) {
            let item = pecas[i];
            let isBO = item.delivery_time.is_BO;

            if (isBO) {
                this.setNovoValorDadosPeca(item, resposta, '');
                continue;
            }

            const dataEntregaString = deliveryDates.find(d => d.day == item.delivery_time.delivery_time_day)?.deliveryDate;
            const dataEntrega = dataEntregaString ? new Date(dataEntregaString) : new Date();
            const calendarStartDate = { year: dataEntrega.getFullYear(), month: dataEntrega.getMonth() + 1, day: dataEntrega.getDate() };

            this.setNovoValorDadosPeca(item, resposta, calendarStartDate);
        }

        resposta.isOnEditMode = true;
    }

    editarResposta_AtualizarFrete(frete) {
        frete.was_changed = true;

        if (frete.conta_comprador || frete.valor <= 0 || frete.valor == null)
            frete.valor = 0;
    }

    editarResposta_AtualizarQuantidades(pedido, lista_pecas) {
        if (!isEmpty(pedido.pecas)) {
            let precoTotal = 0;
            let frete_tipo = (pedido.shipping_cost <= 0 && !pedido.buyer_responsability) ? 1 : 2;
            let frete = { shipping_cost: ((frete_tipo === 1 || pedido.buyer_responsability) ? null : pedido.shipping_cost), buyer_responsability: (frete_tipo === 1 ? false : pedido.buyer_responsability) };
            let valor_frete = (isEmpty(frete.shipping_cost) || frete.buyer_responsability) ? 0 : frete.shipping_cost;

                pedido.pecas.map((peca: Part) => {
                    let peca_alterada = lista_pecas.find(pa => pa.item_id === peca.item_id);

                    if (!isEmpty(peca_alterada))
                        peca.answer_quantity = peca_alterada.quantity;
                    else
                        peca.answer_quantity;

                    peca.preco_final = numberWithTwoDecimals(peca.quantity * peca.unityFinalPrice);
                    precoTotal += peca.preco_final;
                });

            pedido.total_pecas = precoTotal;
            pedido.total_pecas_frete = precoTotal + valor_frete;
        }
    }

    editarResposta_Cancelar(resposta: PurchaseAreaResponse) {
        delete resposta.novoValor;
        resposta.isOnEditMode = !resposta.isOnEditMode;
    }

    editarResposta_FormatarFrete(frete) {
        if (isEmpty(frete.shipping_cost) || frete.shipping_cost === 0) {
            if (frete.buyer_responsability)
                return this.globals.translate('buyer.cotacao.area-respostas.resposta.editar.frete.conta-comprador');
            else
                return this.globals.translate('buyer.cotacao.area-respostas.resposta.editar.frete.gratuito');
        }

        return formatCurrency(frete.shipping_cost, 'pt-BR', 'R$', 'BRL');
    }

    async editarResposta_Salvar(resposta: PurchaseAreaResponse, nAttempts: number) {
        let frete = { answer_in_id: resposta.answer_in_id, shipping_cost: ((resposta.novoValor.frete.tipo == 1 || resposta.novoValor.frete.conta_comprador) ? null : resposta.novoValor.frete.valor), buyer_responsability: (resposta.novoValor.frete.tipo == 1 ? false : resposta.novoValor.frete.conta_comprador), was_changed: resposta.was_changed || resposta.novoValor.frete.was_changed };
        let valor_frete = (isEmpty(frete.shipping_cost) || frete.buyer_responsability) ? 0 : frete.shipping_cost;

        if (!frete.buyer_responsability && resposta.novoValor.frete.tipo == 2 && valor_frete == 0) {
            await this.notificationService.showWarning('buyer.cotacao.mensagens.alterar.erro.dados-invalidos.corpo.frete-zerado', 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo');
            return;
        }

        // Se o fornecedor já tiver configurado as condições de fornecimento e o frete tiver sido alterado, avisa que os dados pre-configurados serão perdidos
        if (resposta.done_configuration && resposta.novoValor.frete.was_changed && !resposta.was_changed && !(await this.notificationService.showConfirmationDialog('buyer.cotacao.area-respostas.resposta.editar.confirm')))
            return;

        let sucesso = true;
        let errorMessage = '';
        let nomePeca = '';
        let listaPecas = [];
        let precoTotal = 0;
        let hoje = new Date();
        hoje.setHours(3, 0, 0);

        // Atualiza a resposta com as novas informações das peças
        for (let i = 0; i <= resposta.pecas.length - 1; i++) {
            let item = resposta.pecas[i];
            nomePeca = item.item_name;
            let n_item = resposta.novoValor.itens[i];

            let delivery_time_id = 99; // BO

            if (!n_item.editIsBO) {
                if (n_item.data_entrega == '' || typeof n_item.data_entrega == 'string')
                {
                    sucesso = false;
                    errorMessage = 'delivery-time-id';
                    break;
                }

                let data_entrega = new Date(n_item.data_entrega.year, n_item.data_entrega.month - 1, n_item.data_entrega.day);

                // Adiciona horas devido a timezone
                data_entrega.setHours(data_entrega.getHours() + 3);
                let working_days = getWorkDaysCount(hoje, data_entrega, this.feriados);

                if (working_days === 0)
                    working_days = 0.5;

                if (working_days <= 1)
                    n_item.editIsPF = false;

                let dtsSelecionados = this.deliveryTimes.filter(dt => dt.delivery_time_day === working_days && dt.is_PF == n_item.editIsPF);
                item.delivery_time = !isEmpty(dtsSelecionados) ? $.extend(true, {}, dtsSelecionados[0]) : item.delivery_time;
                item.delivery_time_day = item.delivery_time.delivery_time_day;

                if (working_days <= 40 && !isEmpty(item.delivery_time))
                    delivery_time_id = item.delivery_time.delivery_time_id;
            }

            if (delivery_time_id == 99) {
                this.setarPecaBO(item)
            }

            item.answer_quantity = isEmpty(n_item.answer_quantity) || n_item.answer_quantity < 1 ? 1 : (n_item.quantity < n_item.answer_quantity ? n_item.quantity : n_item.answer_quantity);
            item.selectedQuantity = 0;
            item.discount_original = item.discount = n_item.discount;
            item.price = n_item.price;
            item.unityFinalPrice = item.price * (1 - (item.discount / 100));
            item.preco_final = numberWithTwoDecimals(item.quantity * item.unityFinalPrice);
            item.preco_final_original = item.preco_final;
            precoTotal += item.preco_final;

            // Realiza a validação
            if (item.item_answer_id <= 0) {
                sucesso = false;
                errorMessage = 'item-answer-id';
                break;
            }

            if (item.price <= 0) {
                sucesso = false;
                errorMessage = 'price';
                break;
            }

            if (delivery_time_id <= 0) {
                sucesso = false;
                errorMessage = 'delivery-time-id';
                break;
            }

            // Monta os dados de retorno
            listaPecas.push({ item_answer_id: item.item_answer_id, item_id: item.item_id, delivery_time_id: delivery_time_id, discount: item.discount, discount_original: item.discount_original, price: item.price, quantity: item.answer_quantity });
        }

        if (!sucesso) {
            let corpo = this.globals.translate('buyer.cotacao.mensagens.alterar.erro.dados-invalidos.corpo.' + errorMessage);
            await this.notificationService.showWarning(corpo.replace('{0}', nomePeca), 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo', false, true);
            return;
        }

        this.calcularMelhorPrecoPrazo();

        resposta.total_pecas = numberWithTwoDecimals(precoTotal);
        resposta.total_pecas_frete = numberWithTwoDecimals(resposta.total_pecas + valor_frete);
        this.atualizarFormaPagamento(resposta);

        // Atualiza a resposta com as novas informações de frete
        if (resposta.novoValor.frete.was_changed) {
            resposta.shipping_cost = valor_frete;
            resposta.frete_formatado = this.editarResposta_FormatarFrete(frete);
            resposta.buyer_responsability = frete.buyer_responsability;
            resposta.was_changed = true;
        }

        this.atualizarDadosPecas([resposta]);

        // Fecha o modo de edição
        this.editarResposta_Cancelar(resposta);

        this.rebuildAnswersFooter();

        this.buyerPurchaseService.changeQuotation(this.cotacaoSelecionada.id, listaPecas, frete, resposta.rebate).subscribe({
            next: (response: ApiResponseModel<number>) => {
                if (response && response.success) {
                    resposta.rebate_potencial = response.result;
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.mensagens.alterar.sucesso.salvar.corpo'));
                }
                else
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.mensagens.alterar.erro.salvar.corpo'));
            },
            error: async (error) => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.listarRespostas(this.transaction_id);
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.mensagens.alterar.erro.salvar.corpo'));
                    return;
                }

                this.editarResposta_Salvar(resposta, ++nAttempts);
            }
        });
    }

    enviar_cotacao() {
        this.ngxLoader.startLoader('loader-principal');

        var pedido: Pedido = {
            companyId:  this.userService.companyId(),
            veiculo: `(${this.cotacaoSelecionada?.license_plate}) ${this.cotacaoSelecionada?.vehicle} - ${this.cotacaoSelecionada?.year}`,
            valor_total: this.valorTotalPedido,
            fornecedores: this.vendedorRespostasFiltradas.filter(res => res.is_chosen).map(resposta => ({
                nome: `${resposta.supplier} (${resposta.company_type}) / ${resposta.seller_name}`,
                frete: resposta.shipping_cost ? resposta.shipping_cost : 0,
                valor_pecas: this.obterTotalPecasNumerico(resposta),
                opcao_faturamento: resposta.faturamento_selecionado?.texto_x,

                pecas: resposta.pecas.filter(peca => peca.is_chosen).map(peca => ({
                    quantidade: peca.quantity,
                    nome: peca.name_code_parttype,
                    marca: peca.brand_formated,
                    valor_unitario: peca.price,
                    desconto: peca.discount,
                    valor_total: peca.preco_final,
                    dias_uteis: peca.delivery_time.prazo_formatado_com_tipo,
                    cia_price: peca.cia_price
                }))
            }))
        }

        this.salvarCacheCotacao(true);
        this.alreadySended = true;

        this.buyerPurchaseService.sendChosenAnswersToRepairerManager(this.transaction_id, pedido).subscribe({
            next: () => {
                this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.mensagens.enviar-cotacao.sucesso.corpo'));
                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error)
                this.ngxLoader.stopLoader('loader-principal');
            }
        })
    }

    filterResponses(filter: string = '') {
        switch (filter)
        {
            case '2': // somente aguardando entrega
                this.vendedorRespostas.forEach(response => {
                    response.pecas.forEach(peca => {
                        peca.displayPart = peca.part_type == 1;
                    })

                    response.has_answer = response.pecas.some(peca => peca.displayPart);
                });
                break;
            case '3': // somente devolvidos
                this.vendedorRespostas.forEach(response => {
                    response.pecas.forEach(peca => {
                        peca.displayPart = peca.part_type != 1;
                    })
                    console.log(response.pecas.some(peca => peca.displayPart))
                    response.has_answer = response.pecas.some(peca => peca.displayPart);
                });
                break;
            default: // todos
                this.vendedorRespostas.forEach(response => {
                    response.pecas.forEach(peca => {
                        peca.displayPart = true;
                    })

                    response.has_answer = response.pecas.some(peca => peca.displayPart);
                })
        }

        this.ordenar_sem_loading(this.vendedorRespostas, this.tipo_ordenacao);
        this.rebuildAnswersFooter()
    }

    imprimir() {
        window.print();
    }

    isEmptyTAC()
    {
        return this.cotacaoSelecionada == null || this.cotacaoSelecionada == undefined;
    }

    listarRespostas(transaction_id: number, isFirstLoad: boolean = false) {
        this.ngxLoader.startLoader('loader-principal');

        forkJoin({
            header: this.buyerPurchaseService.getHeaderInformation(transaction_id),
            answers: this.buyerPurchaseService.getAnswers(transaction_id),
        }).subscribe({
            next: (response: {
                header: ApiResponseModel<HeaderApiResponse>,
                answers: ApiResponseModel<{ responsesInformation: PurchaseAreaResponse[], alertType: TipoAlerta }> }) => {
                if (response.header.result === null) {
                    this.voltar({ corpo: 'buyer.cotacao.mensagens.listar.erro.nao-encontrada', parametro: this.transaction_id });
                    return;
                }

                this.purchaseAreaBaseData = response.header.result.headerInformation;
                this.alreadySended = this.purchaseAreaBaseData.sentRepairerDate != null;

                let part_type = (this.purchaseAreaBaseData.partTypeGenuina ? 1 : 0) + (this.purchaseAreaBaseData.partTypeOriginal ? 2 : 0) + (this.purchaseAreaBaseData.partTypeAlternativa ? 4 : 0);

                this.deliveryTimes = response.header.result.deliveryTimes;

                let holidays = response.header.result.holidays;
                this.feriados = holidays.map(h => h.replace('T05:00:00', ''));

                this.calendarMarkDisabled = (date: NgbDate) => this.buyerService.disableCalendarOnWeekendsAndHolidays(date, this.calendar, this.feriados);

                this.vendedorRespostas = this.ordenar_sem_loading(this.atualizarDadosPecas(response.answers.result.responsesInformation), this.tipo_ordenacao, isFirstLoad);
                this.vendedorRespostas.forEach(r => this.atualizarFormaPagamento(r));

                this.listas.cnpjs = response.header.result.cnpjInformation
                let infosVeiculo = this.purchaseAreaBaseData.vehicleYear.split('-');
                let vehicleYear = infosVeiculo[infosVeiculo.length - 1].trim();

                let vehicleName = this.purchaseAreaBaseData.vehicleYear.replace(' - ' + vehicleYear, '')
                let licensePlate = this.purchaseAreaBaseData.licensePlate

                this.cotacaoSelecionada = {
                    id: transaction_id,
                    transaction_id: transaction_id,
                    vehicle: vehicleName,
                    vehicle_formatted: this.purchaseAreaBaseData.vehicleFormatted,
                    year: vehicleYear,
                    chassi: this.purchaseAreaBaseData.chassi,
                    license_plate: licensePlate,
                    creation_date_formatada: '', //creation_date_formatada,
                    part_type: part_type,
                    creation_duration: this.purchaseAreaBaseData.creationDuration,
                    brand: { name: this.purchaseAreaBaseData.brandName },
                    insurance: { name: this.purchaseAreaBaseData.insuranceName },
                    itens: this.purchaseAreaBaseData.itens,
                    fotos: this.montarFotos(response.header.result.images),
                    seconds_left: 0,
                    is_done_by_support: this.purchaseAreaBaseData.isDoneBySupport,
                    isInsumos: response.header.result.headerInformation.isInsumos
                };

                let veiculo = this.cotacaoSelecionada.vehicle.replace('[O]', '').trim();
                let placa = this.cotacaoSelecionada.license_plate.replace(' ', '').replace('-', '');

                this.isInsumosWithoutVehicle = this.settingService.isQuotationInsumos(placa);

                this.cotacaoEdicao = {
                    quotation_id: transaction_id,
                    marca: this.purchaseAreaBaseData.brandName,
                    chassi: this.cotacaoSelecionada.chassi,
                    vehicle: veiculo,
                    vehicle_year: this.cotacaoSelecionada.year,
                    license_plate: placa,
                    part_type: part_type
                };

                // Inclui os vendedores que ainda não tiveram contatos com o comprador
                this.calcularMelhorPrecoPrazo();
                this.respostaTipoAlerta = response.answers.result.alertType;

                this.buyerPurchaseService.getChosenAnswers(this.cotacaoSelecionada.id).subscribe({
                    next: (response: ApiResponseModel<BuyerPurchasesGetChosenAnswersResponseModel>) => {
                        if (response && response.success && response.result.chosenAnswers.length > 0) {
                            this.isCotacaoSalva = true;
                            this.cotacaoCache = response.result.chosenAnswers;

                            this.toggleAllCache();
                        }
                    },
                    error: () => {
                        this.cotacaoCache = [];
                    }
                });

                this.vendedorRespostasFiltradas = this.vendedorRespostas;
                this.calculatePartIsUsedAnswer();
                this.isScreenLoaded = true;

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);

                this.ngxLoader.stopLoader('loader-principal');
                this.voltar({ corpo: 'buyer.cotacao.mensagens.listar.erro.nao-encontrada', parametro: transaction_id });

                return;
            }
        });
    }

    manipularReader(readerEvt: any)
    {
        var binaryString = readerEvt.target.result;
        return btoa(binaryString);
    }

    modal_abrir(tipo: number)
    {
        let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };

        switch (tipo)
        {
            case 1: // PecasFaltantes
                this.modalPecasFaltantes = this.modalService.show(this.templatePecasFaltantes, { class: 'gray modal-lg' });
                break;
            case 3: // Compra
                // if ($('select[name="cnpjFaturamento"]').length > 0)
                //     $('select[name="cnpjFaturamento"]')[0].selectedIndex = "0";

                // $('select[class*="resposta_"]').each(function (i, resposta) { resposta.selectedIndex = "0"; });

                // // Atualiza os totais
                // this.montarTotalRespostaCompraTodas();
                // this.com_complemento_fiscal = 0;

                // this.modalCompra = this.modalService.show(this.templateCompra, options);
                // setTimeout(() => addTooltip(), 200);
                break;
            case 4: // AdicionarVendedorExterno
                this.modalAdicionarVendedorExterno = this.modalService.show(this.templateAdicionarVendedorExterno, options);
                break;
        }
    }

    modal_adicionar_complemento_abrir($event) {
        $event.stopPropagation();

        this.modal_visivel.adicionar_complemento = true;
    }

    modal_adicionar_complemento_fechar($event)
    {
        this.modal_visivel.adicionar_complemento = false;

        setTimeout(() => {
            if ($event.atualizar) {
                this.listarRespostas(this.transaction_id);
            }
        }, 200);
    }

    modal_adicionar_vendedor_externo_enviar_link(nAttempts: number, ignorarConfirm: boolean, $event)
    {
        $event.stopPropagation();

        let idsPecas = this.vendedorExternoPecasSelecionadas;
        let whatsapp = getOnlyNumbers(this.vendedorExternoForm.value.whatsapp);

        // Caso o vendedor convidado já tiver sido convidado antes e já tenha respondido
        if (this.vendedorRespostas.find(v => getOnlyNumbers(v.seller_phone_whatsapp) === whatsapp))
        {
            this.notificationService.showErrorToastr(this.globals.translate('support.cotacoes.vendedores.adicionar-vendedor-externo.erro-cadastro.vendedor-ja-respondeu.corpo'));
            return;
        }

        let cnpj = getOnlyNumbers(this.vendedorExternoForm.value.cnpj);
        let vendedor = capitalizeFirstLetter(this.vendedorExternoForm.value.vendedor);
        let usuario = { id: 0 };

        const params: SweetAlertParams = {
            icon: 'warning',
            bigSwall: true,
            title: 'buyer.cotacao.mensagens.adicionar-vendedor-externo.confirmacao.titulo',
            showDenyButton: true,
            confirmButtonText: 'buyer.cotacao.mensagens.adicionar-vendedor-externo.confirmacao.responder-pelo-vendedor-externo',
            denyButtonText: 'buyer.cotacao.mensagens.adicionar-vendedor-externo.confirmacao.enviar-mensagem'
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.isDismissed)
                return;

            this.loading.vendedor_externo = true;
            this.buyerPurchaseService.enviarLinkRapido(this.cotacaoSelecionada.id, cnpj, this.vendedorExternoForm.value.empresa, vendedor, whatsapp, usuario.id, idsPecas).subscribe({
                next: (response: ApiResponseModel<SendLinkResponseModel>) => {
                    if (!isEmpty(response) && response.success) {
                        let urlPartsfy = this.generalService.getPartsfyUrl();

                        let urlCotacao = urlPartsfy + '/pedido/' + response.result.token;

                        if(result.isDenied) {
                            let whatsappmessage: WhatsAppMessage = { is_from_support: true, urlPartsfy: urlPartsfy, urlCTA: urlCotacao, vendedor_nome: vendedor.replace(/ .*/, ''), vendedor_whatsapp: whatsapp };

                            this.generalService.whatsapp_enviar_link_rapido_vendedor_externo(whatsappmessage, 0);
                        } else {
                            window.open(urlCotacao, 'novaJanela')
                        }

                        this.listarRespostas(this.cotacaoSelecionada.id);
                    } else {
                        this.notificationService.showWarning('support.cotacoes.mensagens.erro.envio-link-repetido.corpo');
                    }

                    this.loading.vendedor_externo = false;
                    this.modal_fechar(4);
                },
                error: error => {
                    nAttempts = nAttempts || 1;
                    console.log(error, nAttempts);

                    if (nAttempts >= 5) {
                        this.loading.vendedor_externo = false;
                        this.notificationService.showErrorToastr(this.globals.translate('support.cotacoes.mensagens.erro.envio-link.corpo'));
                        return;
                    }

                    this.modal_adicionar_vendedor_externo_enviar_link(++nAttempts, true, $event);
                }
            });
        });

    }

    modal_adicionar_vendedor_externo_selecionar(peca: Item, $event)
    {
        if ($($event.target).is(":checked"))
        {
            this.vendedorExternoPecasSelecionadas.push(peca.id);
        }
        else
        {
            this.vendedorExternoPecasSelecionadas = this.vendedorExternoPecasSelecionadas.filter(p => p != peca.id)
        }

        if (this.vendedorExternoPecasSelecionadas.length === 0)
            $('.todas_pecas').prop("checked", false);
        else if (this.vendedorExternoPecasSelecionadas.length === this.cotacaoSelecionada.itens.length)
            $('.todas_pecas').prop("checked", true);
    }

    modal_adicionar_vendedor_externo_selecionar_todas_pecas($event)
    {
        let is_checked = $($event.target).is(":checked");

        this.cotacaoSelecionada.itens.forEach(peca =>
        {
            this.modal_adicionar_vendedor_externo_selecionar(peca, $event);
        });

        $('.peca_notificacao').prop("checked", is_checked);
    }

    modal_adicionar_vendedor_externo_form_control(nome: string)
    {
        return this.vendedorExternoForm.get(nome) as UntypedFormControl;
    }

    modal_checkout_abrir($event) {
        $event.stopPropagation();

        this.modalCheckoutComponent.quotationId = this.cotacaoSelecionada.id;
        this.modalCheckoutComponent.answerHasCashback = this.vendedorRespostas.some(value => value.has_cashback && value.is_chosen);
        this.modalCheckoutComponent.listas = this.listas;
        this.modalCheckoutComponent.chosenAnswers = deepCopy(this.vendedorRespostas.filter(r => r.is_chosen).map(r => this.toCheckoutAnswer(r)));
        this.modalCheckoutComponent.selectedChosenAnswers = this.respostasPecasSelecionadas().map(r => this.toCheckoutAnswer(r));
        this.modalCheckoutComponent.taxa_cashback_partsfy = this.obterMargemCashbackPartsfy();

        this.modalCheckoutComponent.inicializar();
    }

    toCheckoutAnswer(answer: PurchaseAreaResponse): CheckoutAnswer {
        const checkoutAnswer: CheckoutAnswer = {
            answerId: answer.answer_id,
            class: answer.class,
            classCashback: answer.class_cashback,
            hasCashback: answer.has_cashback,
            isOldAnswer: answer.is_old_response,
            rebate: answer.rebate,
            rebatePartsfy: answer.rebate_partsfy,
            sellerCompanyId: answer.seller_company_id,
            sellerName: answer.seller_name,
            selectedShippingCost: answer.shipping_cost_selecionado,
            tax: answer.tax,
            totalCashback: answer.total_cashback,
            totalChosen: answer.total_selecionado,
            totalChosenFormatted: answer.total_escolhido_formatado,
            totalOriginal: answer.total_original,
            totalOriginalFormatted: answer.total_original_formatado,

            selectedPaymentTypesFormatted: answer.tipos_pagamento_formatado_selecionado,

            parts: answer.pecas.map(p => this.toCheckoutAnswerPart(p))
        };

        return checkoutAnswer;
    }

    toCheckoutAnswerPart(part: Part): CheckoutAnswerPart {
        const checkoutAnswerPart: CheckoutAnswerPart = {
            answerQuantity: part.answer_quantity,
            brandAndType: part.brand_and_type,
            canGenerateCustomizedCashback: part.podeGerarCashbackCustomizado,
            deliveryTimeDay: part.delivery_time_day,
            deliveryTimeFormatted: part.delivery_time.prazo_formatado,
            discount: part.discount,
            discountOriginal: part.discount_original,
            isChosen: part.is_chosen,
            isPF: part.delivery_time.is_PF,
            itemAnswerId: part.item_answer_id,
            itemId: part.item_id,
            itemName: part.item_name,
            price: part.price,
            selectedQuantity: part.selectedQuantity,
            is_used: part.is_used
        };

        return checkoutAnswerPart;
    }

    modal_checkout_fechar(status: CheckoutModalResponseEnum) {
        switch (status) {
            case CheckoutModalResponseEnum.listarRespostas:
                this.listarRespostas(this.transaction_id);
                break;
            case CheckoutModalResponseEnum.voltarVisaoGeral:
                this.voltar(null);
                break;
        }
    }

    modal_checkout_limpar_cache($event) {
        this.isCotacaoSalva = true;
        this.salvarCacheCotacao(false, false);
    }

    modal_editar_cotacao_abrir($event)
    {
        $event.stopPropagation();

        this.modal_visivel.editar_cotacao = true;
    }

    modal_editar_cotacao_fechar($event)
    {
        this.modal_visivel.editar_cotacao = false;

        setTimeout(() =>
        {
            if ($event.atualizar)
            {
                this.listarRespostas(this.transaction_id);
            }
        }, 200);
    }

    modal_fechar(tipo: number)
    {
        switch (tipo)
        {
            case 1: // PecasFaltantes
                this.modalPecasFaltantes.hide();
                break;
            case 2: // MaisDetalhes
                this.modalMaisDetalhes.hide();
                break;
            case 3: // Compra
                this.modalCompra.hide();

                // Ajusta o valor dos descontos para o original
                setTimeout(() => this.vendedorRespostas.map(vr => vr.pecas.map(p => p.discount = p.discount_original)), 200);
                break;
            case 4: // AdicionarVendedorExterno
                this.modalAdicionarVendedorExterno.hide();
        }
    }

    modal_ver_mais_detalhes_abrir($event: any, isComentarios: boolean) {
        $event.stopPropagation();

        this.modal_visivel.comentarios = isComentarios;

        this.modalVerMaisDetalhesComponent.inicializar();
    }

    modal_ver_mais_detalhes_fechar($event: any) {
        const status = $event.status as VerMaisDetalhesModalResponseEnum;

        switch (status) {
            case VerMaisDetalhesModalResponseEnum.listarRespostas:
                this.listarRespostas(this.transaction_id);
                break;
            case VerMaisDetalhesModalResponseEnum.atualizarRespostas:
                const pecaSelecionada = $event.pecaSelecionada;

                if (!isEmpty(this.vendedorRespostas) && pecaSelecionada) {
                    this.listarRespostas(this.transaction_id);
                }
                break;
        }
    }

    montarFotos(fotos)
    {
        if(!fotos) return []

        var result = [];

        for (let foto of fotos)
        {
            result.push({ file: foto, filename: foto.replace(/^.*[\\\/]/, '') });
        }

        return result;
    }

    pedirAjuda()
    {
        if (this.isUsuarioLocalPlanoPopular) {
            this.buyerService.pedirAjudaPopularModal();
        }
        else // Se for outro plano, abre o motivo e volta para o cotador
        {
            this.buyerService.enviarCotacaoCotador((pediu_ajuda, motivo) =>
            {
                if (pediu_ajuda && !isEmpty(motivo))
                    this.pedirAjudaExecutar(motivo, 0);
            });
        }
    }

    pedirAjudaExecutar(motivo: string, nAttempts: number)
    {
        this.ngxLoader.startLoader('loader-principal');

        this.buyerService.enviarCotacaoCotadorExecutar(this.cotacaoSelecionada.id, motivo, nAttempts,
            () => { this.cotacaoSelecionada.is_done_by_support = false; },
            () => { this.ngxLoader.stopLoader('loader-principal'); });
    }

    openSellerReviewModal(response: PurchaseAreaResponse) {
        var selectedOrder = {
            quotationId: this.transaction_id,
            sellerCompanyId: response.seller_company_id,
            brandName: response.brand_name
        }

        this.modalRespostaAvaliacaoComponent.open(selectedOrder, this.userService.userIsCentral());
    }

    openSellerWhatsapp(response: PurchaseAreaResponse) {
        let sellerPhone = getOnlyNumbers(response.seller_whatsapp);

        this.generalService.whatsapp_abrir_conversa(sellerPhone);
    }

    obterClass(header: PurchaseAreaResponse, peca: any)
    {
        var item: Part = findInArray(header.pecas, "item_id", peca.item_id);

        if (item === null)
            return 'erro-sem-item';

        item.other_selected = item.other_selected == undefined ? false : item.other_selected;
        return peca.is_chosen ?
            'selected' :
            (item.other_selected ? 'other-selected' : '');
    }

    obterMargemCashbackPartsfy() {
        let respostasValidas = this.vendedorRespostas.find(r => r.pecas.length > 0 && r.cashback_partsfy_comission && r.cashback_partsfy_comission > 0);

        if (!isEmpty(respostasValidas))
            return respostasValidas.cashback_partsfy_comission;

        return 40;
    }

    obterTotalPecas(resposta: PurchaseAreaResponse) {
        return formatCurrency(this.obterTotalPecasNumerico(resposta), 'pt-BR', 'R$', 'BRL');
    }

    obterTotalPecasNumerico(resposta: PurchaseAreaResponse) {
        var itens = resposta.pecas;
        var total = 0;

        for (var i = 0; i <= itens.length - 1; i++)
        {
            var item = itens[i];

            if (item.is_chosen && item.displayPart)
                total += item.preco_final;
        }

        return total;
    }

    onBlurDiscount(peca: any) {
        if (!peca.discount || peca.discount < 0)
            peca.discount = 0;
    }

    ordenar(tipo_ordenacao)
    {
        this.ngxLoader.startLoader('loader-principal');
        this.tipo_ordenacao = tipo_ordenacao;
        this.vendedorRespostas = this.ordenar_sem_loading(this.vendedorRespostas, tipo_ordenacao);
        this.vendedorRespostasFiltradas = this.vendedorRespostas;
        this.calculatePartIsUsedAnswer();
        this.ngxLoader.stopLoader('loader-principal');
    }

    ordenar_sem_loading(respostas: PurchaseAreaResponse[], tipoOrdenacao, isFirstLoad: boolean = false) {
        const sortingParams: { name: string, primer?: any, reverse?: boolean }[] = [
            { name: 'choose_not_participate' },
            { name: 'has_answer', reverse: true }
        ];

        if (isFirstLoad) {
            sortingParams.push({ name: 'rejected_status_id', reverse: true });
        }

        switch (tipoOrdenacao) {
            case '1': // Tem cashback
                sortingParams.push(
                    { name: 'has_cashback', reverse: true },
                    { name: 'cashback_potencial', primer: parseFloat, reverse: true },
                    { name: 'is_billable', reverse: true }
                );
                break;
            case '2': // Melhores vendedores
                sortingParams.push(
                    { name: 'is_billable', reverse: true },
                    { name: 'score_star', reverse: true }
                );
                break;
            default: // Menor preço
                break;
        }

        sortingParams.push({ name: 'total_pecas_frete', primer: parseFloat });
        sortingParams.push({ name: 'supplier' });

        respostas.sort(sort_by(sortingParams));

        return respostas;
    }

    onInputAnswerQuantityChange(event: any, peca: any): void {
        const inputValue = event.target.value;
        const maxDigits = peca.quantity.toString().length;

        if (inputValue.length > maxDigits) {
            event.target.value = inputValue.slice(0, maxDigits);
            peca.answer_quantity = parseInt(event.target.value, 10) || 0;
        }
    }

    pecasSelecionadas() {
        if (isEmpty(this.vendedorRespostas))
            return 0;

        var total = 0;

        for (var i = 0; i <= this.vendedorRespostas.length - 1; i++) {
            var item = this.vendedorRespostas[i];
            if (item.is_chosen)
                total += 1;
        }

        return total;
    }

    rebuildAnswersFooter() {
        this.respostasRodape.forEach((rr) => { rr.recalcularComponente(); });
    }

    respostasPecasSelecionadas() {
        var filtered: PurchaseAreaResponse[] = [];

        this.vendedorRespostas.forEach(function (resposta: PurchaseAreaResponse) {
            if (resposta.pecas.length > 0) {
                var pecas = resposta.pecas;

                for (var i = 0; i <= pecas.length - 1; i++) {
                    if (pecas[i].is_chosen) {
                        filtered.push(resposta);
                        break;
                    }
                }
            }
        });

        return filtered;
    }

    salvarCacheCotacao(is_enviar_cotacao: boolean = false, send_toastr: boolean = true) {
        const isLiberar = this.isCotacaoSalva && !is_enviar_cotacao;
        const newValue = isLiberar ? [] : [...this.cotacaoCachePecasSelecionadas];

        this.buyerPurchaseService.setChosenAnswers(this.cotacaoSelecionada.id, newValue, is_enviar_cotacao).subscribe({
            next: () => {
                const type = isLiberar ? this.globals.translate('buyer.cotacao.mensagens.salvar-cache.tipo.liberada') : this.globals.translate('buyer.cotacao.mensagens.salvar-cache.tipo.salva');
                this.isCotacaoSalva = !isLiberar;
                this.cotacaoCache = newValue;

                if (isLiberar) {
                    this.toggleAllCache();
                }

                if(send_toastr) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.mensagens.salvar-cache.sucesso.corpo').replace('{type}', type));
                }

                if (isLiberar)
                    this.alreadySended = false;
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');

                if (error.status === 404) {
                    this.voltar({ corpo: 'buyer.cotacao.mensagens.listar.erro.nao-encontrada', parametro: this.cotacaoSelecionada.id });
                }
                else {
                    const type = isLiberar ? this.globals.translate('buyer.cotacao.mensagens.salvar-cache.tipo.liberar') : this.globals.translate('buyer.cotacao.mensagens.salvar-cache.tipo.salvar');
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.mensagens.salvar-cache.erro.corpo').replace('{type}', type));
                }
            }
        })
    }

    selecionarPeca($this, resposta: PurchaseAreaResponse, peca: Part, vendedorRespostas: PurchaseAreaResponse[], reiniciarCache: boolean = false, selectAll: boolean = false) {
        if(peca.displayPart == false)
            return;

        if ($this == null)
            $this = this;

        var item = findInArray(resposta.pecas, "item_id", peca.item_id);

        if (item != null) {
            if (reiniciarCache) {
                $this.isCotacaoSalva = false;
                $this.alreadySended = false;
            }

            if (selectAll || peca.quantity == 1)
                item.selectedQuantity = !item.is_chosen ? (item.answer_quantity > item.quantity ? item.quantity : item.answer_quantity) : 0;

            peca.is_chosen = !peca.is_chosen || peca.selectedQuantity > 0;
            item.is_chosen = peca.is_chosen;

            if (peca.is_chosen)
                item.other_selected = peca.other_selected = false;

            // Percorre todas as peças para verificar se deve ou não mudar o header
            $this.verificarHeader(resposta);

            // Seta o tipo de frete baseado nas condições de fornecimento do fornecedor
            $this.setarTipoFrete(resposta);

            // Obtém o total selecionado desta resposta
            let totalPedido = 0;
            resposta.total_selecionado = $this.buyerPurchaseService.getOrderValueFromAnswer(resposta, TipoCalculoTotalEnum.TotalEscolhido).total;
            totalPedido = resposta.total_selecionado;

            // Seta o tipo de faturamento baseado nas condições de fornecimento do fornecedor
            $this.setarTipoFaturamento(resposta);

            var respostasPositivas = vendedorRespostas.filter(vr => !isEmpty(vr.answer_in_id) && (vr.answer_in_id !== resposta.answer_in_id));

            // Desabilita as peças dos outros vendedores
            for (var i = 0; i <= respostasPositivas.length - 1; i++) {
                var respostaSelecionada = respostasPositivas[i];
                var itemSelecionado: Part = findInArray(respostaSelecionada.pecas, "item_id", peca.item_id);

                if (!isEmpty(itemSelecionado)) {
                    itemSelecionado.other_selected = false;
                    itemSelecionado.other_selected_quantity = 0;

                    if (peca.is_chosen) { // Se a peça foi selecionada, marca que outra está selecionada
                        itemSelecionado.other_selected = true;
                        itemSelecionado.other_selected_quantity = peca.selectedQuantity;

                        if (selectAll) {
                            peca.other_selected_quantity = 0;
                            peca.other_selected = false;
                            itemSelecionado.selectedQuantity = 0;
                        }

                        itemSelecionado.is_chosen = peca.answer_quantity != peca.selectedQuantity && itemSelecionado.selectedQuantity > 0;
                    }
                }

                $this.verificarHeader(respostaSelecionada);
                const calculoTotal = $this.buyerPurchaseService.getOrderValueFromAnswer(respostaSelecionada, TipoCalculoTotalEnum.TotalEscolhido);
                respostaSelecionada.total_selecionado = calculoTotal.total;
                totalPedido += respostaSelecionada.total_selecionado;
                $this.setarTipoFaturamento(respostaSelecionada);
            }

            // Faz o ajuste do limite
            $this.acertarLimites(vendedorRespostas);

            // Define o total selecionado
            $this.valorTotalPedido = totalPedido;

            // Atualiza o cache
            $this.atualizarCache();

            setTimeout(function () { $(window).resize(); }, 500);
        }

        $this.rebuildAnswersFooter();
    }

    setEditIsBO(peca: EditPartItem) {
        if(peca.editIsBO) {
            peca.data_entrega = ''
            peca.showPF = false;
        } else {
            let hoje = new Date();
            hoje.setHours(3, 0, 0);

            peca.data_entrega = { year: hoje.getFullYear(), month: hoje.getMonth() + 1, day: hoje.getDate() }
        }
    }

    setarPecaBO(item: Part) {
        item.delivery_time.delivery_time_id = 99,
        item.delivery_time.delivery_time_day = null
        item.delivery_time.delivery_time_type = "BO",
        item.delivery_time.is_active = true
        item.delivery_time.type_name = "Back Order"
        item.delivery_time.delivery_time_name_resumo = "BO",
        item.delivery_time.prazo_formatado = "BO"
        item.delivery_time.prazo_formatado_com_tipo = "BO",
        item.delivery_time.is_PE = false,
        item.delivery_time.is_PF = false,
        item.delivery_time.is_BO = true
    }

    setNovoValorDadosPeca(item: Part, resposta: PurchaseAreaResponse, calendarStartDate: any) {
        let editIsBO = item.delivery_time.is_BO;
        let editIsPF = item.delivery_time.is_PF;
        let lockPF = item.delivery_time.delivery_time_day > 4;
        let showPF = item.delivery_time.delivery_time_day > 1;
        let preco_final = numberWithTwoDecimals(item.price * (1 - (item.discount / 100)));
        let peca_name = item.item_name;
        let hasNewPartCode = item.new_part_code && item.new_part_code.length > 0;

        if (hasNewPartCode) {
            peca_name = `${item.new_part_code} - ${peca_name}`;
        } else if (item.item_part_code) {
            peca_name = `${item.item_part_code} - ${peca_name}`;
        }

        item.is_chosen = false;
        resposta.novoValor.itens.push({
            id: item.item_answer_id,
            editIsBO,
            editIsPF,
            showPF,
            lockPF,
            data_entrega: calendarStartDate,
            discount_original: item.discount_original,
            discount: item.discount,
            price: item.price,
            preco_final: preco_final,
            answer_quantity: item.answer_quantity,
            quantity: item.quantity,
            selectedQuantity: item.selectedQuantity,
            delivery_time: item.delivery_time,
            name: peca_name,
            item_name: item.item_name
        });
    }

    setarTipoFaturamento(resposta: PurchaseAreaResponse)
    {
        let lista_faturamentos: PaymentType[] = [];

        // Insere na lista as formas que estão acima do valor selecionado E não são a vista E estão na lista que foi selecionada pelo vendedor
        if (!isEmpty(resposta) && !isEmpty(resposta.payment_types))
            lista_faturamentos = resposta.payment_types.filter(fp => fp.startValue <= resposta.total_selecionado && fp.paymentTypeId > 0).map(fp => fp.paymentType);
        //  && !isEmpty(resposta.tiposPagamentoFormatado.find(tp => tp.id === fp.payment_type_id))
        else if (resposta.tipos_pagamento_formatado.length > 0 && resposta.can_be_financed)
            lista_faturamentos.push({ texto_x: resposta.tipos_pagamento_formatado[0].name, id: resposta.tipos_pagamento_formatado[0].id });

        if (lista_faturamentos.filter(f => f.id === 0).length <= 0)
            lista_faturamentos.push({ texto_x: this.globals.translate('buyer.cotacao.area-comprar.selecionados.rodape.faturamento.a-vista-br'), id: 0 });

        // Ordena a lista pela maior opção
        lista_faturamentos.sort(sort_by([{ name: 'id', reverse: true }]));

        resposta.faturamento_selecionado = lista_faturamentos[0];
        resposta.tipos_pagamento_formatado_selecionado = resposta.tipos_pagamento_formatado.filter(tp => tp.id <= resposta.faturamento_selecionado.id);
    }

    setarTipoFrete(resposta: PurchaseAreaResponse) {
        let lista_fretes: Shipping[] = [];

        // Insere na lista os fretes da região da oficina
        if (!isEmpty(resposta) && resposta.done_configuration && !isEmpty(resposta.shipping))
            lista_fretes = resposta.shipping;

        if (isEmpty(lista_fretes) || resposta.was_changed) {
            resposta.shipping_cost_selecionado = resposta.shipping_cost;
            resposta.buyer_responsability_selecionado = resposta.buyer_responsability;
        }
        else {
            let total_pecas = this.obterTotalPecasNumerico(resposta);
            let frete = lista_fretes[0];
            resposta.buyer_responsability_selecionado = frete.buyer_payer;
            resposta.shipping_cost_selecionado = frete.buyer_payer || total_pecas >= frete.min_value || frete.shipping_cost === 0 ? null : frete.shipping_cost;
        }

        let por_conta_comprador = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.frete.conta-comprador');
        let frete_gratuito = this.globals.translate('buyer.mercado-partsfy.carrinho.footer.informacoes-preco.frete-gratis');

        resposta.frete_formatado_selecionado = resposta.buyer_responsability_selecionado ? por_conta_comprador : (isEmpty(resposta.shipping_cost_selecionado) ? frete_gratuito : formatCurrency(resposta.shipping_cost_selecionado, 'pt-BR', 'R$', 'BRL'));
    }

    toggleAll(resposta: PurchaseAreaResponse, vendedorRespostas: PurchaseAreaResponse[], $event)
    {
        var selected = resposta.is_chosen;
        var itens = resposta.pecas;
        var header = resposta;
        var selecionarPeca = this.selecionarPeca;
        var $this = this;

        $.each(itens, function (i, item: Part)
        {
            item.is_chosen = selected;
            selecionarPeca($this, header, item, vendedorRespostas, true, true);
        });
    }

    toggleAllCache() {
        if (this.cotacaoCache.length === 0) {
            const respostasComPecasSelecionadas = this.respostasPecasSelecionadas();

            respostasComPecasSelecionadas.map(resposta => {
                resposta.pecas.filter(i => i.is_chosen).forEach(async (item) => {
                    if (item.quantity === 1)
                        this.selecionarPeca(this, resposta, item, this.vendedorRespostas);
                    else {
                        item.selectedQuantity = 0;
                        this.changeSelectedQuantity(item, this.vendedorRespostas);
                    }
                });
            });

            return;
        }

        this.vendedorRespostas.filter(vr => vr.has_answer).map(resposta => {
            resposta.pecas.map(item => {
                if (this.cotacaoCache.some(c => c.item_answer_id == item.item_answer_id)) {
                    waitForElm(`#item-${item.item_answer_id}`).then(async (elm) => {
                        if (item.quantity === 1)
                            this.selecionarPeca(this, resposta, item, this.vendedorRespostas);
                        else {
                            const itemCached = this.cotacaoCache.find(c => c.item_answer_id == item.item_answer_id);

                            item.selectedQuantity = itemCached.quantity;
                            this.changeSelectedQuantity(item, this.vendedorRespostas);
                        }
                    });
                }
            });
        });
    }

    verificarHeader(header: PurchaseAreaResponse)
    {
        var qtdSelecionadas = 0;
        $.each(header.pecas, function (i, _item: Part)
        {
            if (_item.is_chosen)
                qtdSelecionadas++;
        });

        header.is_chosen = qtdSelecionadas > 0;
        header.total_itens_selecionados = qtdSelecionadas
    }

    voltar(errorMessage: { corpo: string, parametro: any } | null) {
        if (!isEmpty(errorMessage)) {
            this.translate.get(errorMessage.corpo).subscribe(corpo => {
                this.notificationService.showErrorToastr(corpo.replace("#xxx", "#" + errorMessage.parametro));
            });
        }

        let previousPage = this.buyerService.obterPaginaAnteriorSemaforoVisaoGeral(this.routingState.getHistory());
        this.router.navigate([previousPage]);
    }

    whatsapp_enviar(vendedor: PurchaseAreaResponse) {
        const companyName = this.userService.user()?.selectedUser?.current_company_name;

        let urlPartsfy = this.generalService.getPartsfyUrl();
        let urlCotacao = urlPartsfy + '/vendedor/visao-geral/responder/' + this.cotacaoSelecionada.id;
        let oficina = companyName;
        let veiculo = this.cotacaoSelecionada.brand.name + " - (" + this.cotacaoSelecionada.license_plate + ") " + this.cotacaoSelecionada.vehicle + " - " + this.cotacaoSelecionada.year;
        let chassi = this.cotacaoSelecionada.chassi;
        let whatsapp = vendedor.seller_whatsapp;
        let vendedor_email = vendedor.seller_email;
        let vendedor_id = vendedor.seller_id;

        let whatsapp_message: WhatsAppMessage = { is_from_support: false, chassi: chassi, oficina: oficina, urlPartsfy: urlPartsfy, urlCTA: urlCotacao, veiculo: veiculo, vendedor_whatsapp: whatsapp, vendedor_email, vendedor_id };

        this.generalService.whatsapp_enviar_responder(whatsapp_message, this.cotacaoSelecionada.id);
    }
}
